"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomField = void 0;
var tslib_1 = require("tslib");
var checkbox_icon_1 = require("./checkbox-icon");
var contact_form_utils_1 = require("../contact-form-utils");
var answers_api_1 = require("@wix/answers-api");
var React = require("react");
// import * as ReactSelect from 'react-select';
var answers_ui_libby_1 = require("@wix/answers-ui-libby");
var answers_lib_1 = require("@wix/answers-lib");
var public_multilevel_field_1 = require("../../public-multilevel-field");
var answers_experiments_1 = require("@wix/answers-experiments");
var CustomField = /** @class */ (function (_super) {
    tslib_1.__extends(CustomField, _super);
    function CustomField() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tp = function (key, params) {
            if (params === void 0) { params = {}; }
            return _this.props.t("common.contact-form.custom-field." + key, params);
        };
        _this.onValueChange = function (value) { return _this.props.onCustomFieldChange(_this.props.customField.name, value); };
        _this.onTargetValueChange = function (e) { return _this.onValueChange(e.target.value); };
        _this.onCheckboxChange = function (e) { return _this.onValueChange(e.target.checked); };
        _this.onSelectChange = function (option) { return _this.onValueChange(option.value); };
        _this.onNumericChange = function (value) {
            var newValue = value ? value : '';
            _this.onValueChange(newValue);
        };
        _this.onAccessibilityKeyup = function (e) {
            if (e.keyCode === answers_api_1.KeyCode.ENTER || e.keyCode === answers_api_1.KeyCode.SPACE) {
                var name_1 = ".checkbox-item." + _this.props.customField.name;
                var checkboxElement = document.querySelector(name_1);
                if (checkboxElement) {
                    checkboxElement.click();
                }
            }
        };
        _this.onAccessibilityClick = function () {
            if (document.activeElement && document.activeElement.blur) {
                document.activeElement.blur();
            }
        };
        _this.setCheckboxRef = function (elem) {
            if (elem) {
                _this.checkBoxRef = elem;
                elem.addEventListener('keyup', _this.onAccessibilityKeyup);
                elem.addEventListener('click', _this.onAccessibilityClick);
            }
        };
        return _this;
    }
    CustomField.prototype.componentWillUnmount = function () {
        if (this.checkBoxRef) {
            this.checkBoxRef.removeEventListener('keyup', this.onAccessibilityKeyup);
            this.checkBoxRef.removeEventListener('click', this.onAccessibilityClick);
        }
    };
    CustomField.prototype.render = function () {
        var props = this.props;
        var customField = props.customField;
        var fieldValue = props.fieldValue;
        var fieldData = customField.data || customField.multiLevelData;
        var fieldName = customField.name;
        var fieldType = answers_api_1.CustomFieldType[customField.type];
        var showCustomFieldError = props.showError && ((!fieldValue && customField.mandatory) || !!props.validationError);
        var customFieldErrorMsg = (React.createElement(contact_form_utils_1.ErrorMsg, { msg: props.validationError || this.tp('error.mandatory'), isVisible: showCustomFieldError }));
        var containerClassNames = "custom-field-container";
        var titleComp = fieldData.title ? React.createElement("div", { className: 'cf-title' }, fieldData.title) : null;
        var descriptionComp = fieldData.description ? React.createElement("div", { className: 'cf-description' }, fieldData.description) : null;
        switch (customField.type) {
            case answers_api_1.CustomFieldType.TEXT:
                var inputValue = fieldValue;
                return (React.createElement("label", { className: containerClassNames, "data-type": fieldType, "data-name": fieldName },
                    titleComp,
                    descriptionComp,
                    React.createElement("input", { type: 'text', value: inputValue, onChange: this.onTargetValueChange, placeholder: fieldData.placeHolder, "aria-invalid": showCustomFieldError }),
                    customFieldErrorMsg));
            case answers_api_1.CustomFieldType.MULTILINE_TEXT:
                var textareaValue = fieldValue;
                return (React.createElement("label", { className: containerClassNames, "data-type": fieldType, "data-name": fieldName },
                    titleComp,
                    descriptionComp,
                    React.createElement("textarea", { "aria-invalid": showCustomFieldError, value: textareaValue, onChange: this.onTargetValueChange, placeholder: fieldData.placeHolder }),
                    customFieldErrorMsg));
            case answers_api_1.CustomFieldType.BOOLEAN:
                var checkboxValue = fieldValue;
                var isChecked = !!checkboxValue ? 'checked' : '';
                var val = fieldValue;
                return (React.createElement("div", { className: containerClassNames, "data-type": fieldType, "data-name": fieldName },
                    titleComp,
                    descriptionComp,
                    React.createElement("label", { tabIndex: 0, ref: this.setCheckboxRef, className: "checkbox-label " + isChecked },
                        React.createElement(checkbox_icon_1.CheckboxIcon, null),
                        React.createElement("input", { type: 'checkbox', className: answers_lib_1.classNames('checkbox-item', fieldName, 'checkbox'), value: val, onChange: this.onCheckboxChange, "aria-label": 'checkbox', "aria-hidden": 'false', "aria-invalid": showCustomFieldError, checked: checkboxValue }),
                        React.createElement("span", null, fieldData.placeHolder)),
                    customFieldErrorMsg));
            case answers_api_1.CustomFieldType.NUMBER: {
                var numberValue = fieldValue;
                var value = numberValue !== undefined ? numberValue : null;
                var placeholder = fieldData.placeHolder;
                return (React.createElement("div", { className: containerClassNames, "data-type": fieldType, "data-name": fieldName },
                    titleComp,
                    descriptionComp,
                    React.createElement(answers_ui_libby_1.NumericInput, { value: value, onChange: this.onNumericChange, placeholder: placeholder }),
                    customFieldErrorMsg));
            }
            // TODO
            // case CustomFieldType.DATE:
            // TODO
            // case CustomFieldType.MULTI_SELECT
            case answers_api_1.CustomFieldType.SINGLE_SELECT:
                var selectValue = fieldValue;
                var options = customField.data.values.map(function (value) { return ({ value: value, label: value }); });
                return (React.createElement("div", { className: containerClassNames, "data-type": fieldType, "data-name": fieldName },
                    titleComp,
                    descriptionComp,
                    React.createElement(answers_ui_libby_1.DeprecatedSelect, { value: selectValue, onChange: this.onSelectChange, options: options, placeholder: fieldData.placeHolder, useSelectV3: false }),
                    customFieldErrorMsg));
            case answers_api_1.CustomFieldType.MULTI_LEVEL:
                var texts = {
                    placeholder: this.tp('multilevel.placeholder'),
                    clearText: this.tp('multilevel.clear')
                };
                var onChange = function (data) {
                    props.onCustomFieldChange(props.customField.name, data.value);
                };
                var isMandatory = props.customField.mandatory || false;
                if (!answers_experiments_1.isFeatureEnabled('MultilevelFieldsHelpcenter')) {
                    return null;
                }
                var validationError = props.validationError || this.tp('multilevel.mandatory');
                return (React.createElement("div", { className: "custom-field-container " + (!isMandatory ? 'not-mandatory' : ''), "data-value": fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.toString() },
                    React.createElement(public_multilevel_field_1.PublicMultilevelField, { value: (fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.toString()) || '', field: props.customField, validationError: props.showError ? validationError : '', texts: texts, mandatory: isMandatory, onChange: onChange, locale: props.locale })));
            default:
                return null;
        }
    };
    return CustomField;
}(React.Component));
exports.CustomField = CustomField;
//# sourceMappingURL=custom-field.js.map